import React from "react"

import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import {
  ADHOC_CODE_MAX_LENGTH,
  ADHOC_CODE_PREFIX,
  adhocRouteCodePreview,
  normaliseAdhocCustomCode,
} from "@/lib/adhocRouteCode"

interface AdhocCodeFieldProps {
  value: string
  onChange: (value: string) => void
  /** Distinct per dialog: three of these can exist in one mounted tree. */
  id: string
  labelClassName?: string
  /** Required on the create dialog; a duplicate already has its source's code. */
  required?: boolean
}

/**
 * Shared by the create and both duplicate dialogs so the rules can't drift. Normalises as you type
 * rather than validating on submit.
 */
const AdhocCodeField: React.FC<AdhocCodeFieldProps> = ({
  value,
  onChange,
  id,
  labelClassName,
  required = false,
}) => (
  <div className="grid gap-2">
    <Label htmlFor={id} className={labelClassName}>
      {required ? "Route code *" : "Route code (optional)"}
    </Label>
    <div className="flex items-center gap-1.5">
      <span className="text-sm font-medium text-palette-jungleGreen500">{ADHOC_CODE_PREFIX}-</span>
      <Input
        id={id}
        value={value}
        onChange={(e) => onChange(normaliseAdhocCustomCode(e.target.value))}
        placeholder="FUELRUN1"
        className="h-9 w-36 bg-white font-mono uppercase"
        maxLength={ADHOC_CODE_MAX_LENGTH}
        autoComplete="off"
        spellCheck={false}
      />
    </div>
    {!required && (
      <p className="text-xs text-palette-jungleGreen500">
        {value
          ? `This route will be created as ${adhocRouteCodePreview(value)}.`
          : `Leave blank for a generated code. Up to ${ADHOC_CODE_MAX_LENGTH} letters or digits.`}
      </p>
    )}
  </div>
)

export default AdhocCodeField
